import { isArray } from 'lodash/fp'
import * as v from 'valibot'

import { getLocalStorageItem } from './getLocalStorageItem'
import {
  LocalStorageKey,
  LocalStorageValue,
  localStorageSchema,
} from './localStorageSchema'
import { setLocalStorageItem } from './setLocalStorageItem'

type ArrayStorageKey = {
  [K in LocalStorageKey]: LocalStorageValue<K> extends readonly unknown[]
    ? K
    : never
}[LocalStorageKey]

type ObjectStorageKey = {
  [K in LocalStorageKey]: LocalStorageValue<K> extends object ? K : never
}[LocalStorageKey]

export const updateLocalStorageItem = <
  K extends Exclude<ObjectStorageKey, ArrayStorageKey>,
>(
  key: K,
  value: Partial<LocalStorageValue<K>>,
) => {
  const storedValue = getLocalStorageItem(key) || {}

  // This helper merges plain objects; arrays should not be handled here.
  if (isArray(storedValue)) {
    return
  }

  const { output, success } = v.safeParse(localStorageSchema[key], {
    ...storedValue,
    ...value,
  })

  if (success) {
    setLocalStorageItem(key, output)
  }
}
